import * as React from 'react'
export const SvgAccountIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} {...props}>
    <path d="M12 10a3 3 0 100-6 3 3 0 000 6zm0 2a5 5 0 11.001-10.001A5 5 0 0112 12zm-7 9H3c0-3.866 4.03-7 9-7s9 3.134 9 7h-2c0-2.636-3.04-5-7-5s-7 2.364-7 5z" />
  </svg>
)
export default SvgAccountIcon
